import Banner1 from "../components/image/Banner1.jpg";
import Banner2 from "../components/image/Banner2.jpg";
import Banner4 from "../components/image/Banner4.jpg";
import Kd1 from "../components/image/kd1.jpg";

export const ACADEMIC_PAGES = [
  {
    path: "/academics",
    eyebrow: "Academics",
    title: "Academics at S-TEE Schools",
    description: "At S-TEE Schools, learning is a shared adventure. Our classrooms are filled with curiosity, laughter, and encouragement. We blend the Nigerian curriculum with a global perspective, helping every child grow in confidence and character from Nursery through Secondary.",
    heroImage: Banner2,
    heroImageAlt: "Students learning together in class",
    stats: [
      { value: "Nursery", label: "strong early foundations" },
      { value: "Primary", label: "confident core learning" },
      { value: "Secondary", label: "future-focused growth" },
    ],
    focus: {
      label: "Academic Direction",
      title: "Strong teaching works best when it is supported by values and structure",
      text:
        "At S-TEE, academics are not treated in isolation. Learning is supported by clear expectations, values-led school culture, and a steady focus on long-term student growth.",
      list: [
        "A curriculum shaped by national standards and broader global readiness.",
        "Teachers who guide learners as mentors, coaches, and positive role models.",
        "A school environment that keeps effort, discipline, and progress visible.",
      ],
    },
    callout: {
      label: "School Identity",
      title: "Academics become stronger when culture, anthem, and creed stay visible",
      text:
        "Together, school culture, anthem, and creed show that S-TEE is building more than academic results. It is shaping attitude, identity, and leadership too.",
      ctaLabel: "Explore S-Tee Culture",
      ctaPath: "/academics/culture",
    },
    cardsSection: {
      label: "What Shapes Learning",
      title: "The building blocks behind the academic experience",
      items: [
        {
          title: "Curriculum Depth",
          text:
            "Learners are guided through a structured academic journey designed to build understanding, confidence, and long-term readiness.",
        },
        {
          title: "Character And Leadership",
          text:
            "Academic progress is reinforced by discipline, responsibility, respect, and the mindset to lead well.",
        },
        {
          title: "Shared School Identity",
          text:
            "School culture, anthem, and creed help students connect what they learn with how they live and represent the school.",
        },
      ],
    },
    stepsSection: {
      label: "Explore This Area",
      title: "Where to go deeper in the S-TEE academic story",
      items: [
        {
          title: "Explore school culture",
          text:
            "See the standards, routines, and expectations that shape student life on and off campus.",
        },
        {
          title: "Read the school anthem",
          text:
            "Discover the shared expression of pride, belonging, and aspiration used in key school moments.",
        },
        {
          title: "Read the school creed",
          text:
            "Understand the commitments and values students are encouraged to live by every day.",
        },
      ],
    },
    footerCta: {
      title: "Ready to connect academics with the next family step?",
      text:
        "Move into admissions to see how prospective families can begin the S-TEE journey.",
      ctaLabel: "Visit Admissions",
      ctaPath: "/admissions",
    },
  },
  {
    path: "/academics/online",
    eyebrow: "Online School",
    title: "Online School Registration",
    description: "You can now get the same rich world-class education S-TEE is known for irrespective of your location through our Online School.",
    heroImage: require("../components/image/Online-Class1.webp"),
    heroImageAlt: "S-TEE Online Class",
    gallerySection: {
      images: [
        { src: require("../components/image/Online-Class1.webp"), alt: "Online Class Session 1", tag: "Live Class" },
        { src: require("../components/image/Online-Class2.webp"), alt: "Online Class Session 2", tag: "Interactive" }
      ]
    },
    stats: [
      { value: "Anywhere", label: "Global Access" },
      { value: "Flexible", label: "Modern Learning" },
      { value: "S-TEE Quality", label: "World-Class" }
    ],
    focus: {
      label: "Why Choose S-TEE Online?",
      title: "A World-Class Education, Wherever You Are",
      text: "The S-TEE Online School, started after the Covid-19 pandemic, is designed to cater for students who are outside the location of S-TEE Schools but desire the same world-class education S-TEE is reputed for. As online schooling is now an alternate to in-person education, the S-TEE Online School now caters for a variety of students both within and outside our geographical location.",
      list: [
        "Engaging live classes with experienced S-TEE teachers",
        "Interactive lessons and real-time feedback",
        "Support for students and parents throughout the learning journey",
        "Flexible schedules to fit your family's needs"
      ]
    },
    callout: {
      label: "How It Works",
      title: "Simple, Supportive, and Effective",
      text: "Our online program is built for clarity and confidence. Parents and students receive clear communication, ongoing support, and a seamless path to admissions—whether they stay online or return to campus.",
      ctaLabel: "Start Registration",
      ctaPath: "/admissions/online"
    },
    cardsSection: {
      label: "Online School Features",
      title: "What makes S-TEE Online unique?",
      items: [
        {
          title: "Live Classes",
          text: "Engage in real-time lessons with S-TEE teachers from anywhere."
        },
        {
          title: "Interactive Learning",
          text: "Participate in discussions, quizzes, and group activities online."
        },
        {
          title: "Flexible Schedules",
          text: "Learn at times that fit your family's needs."
        }
      ]
    },
    statementSection: {
      label: "Our Commitment",
      title: "Quality and Support",
      text: "S-TEE Online School is committed to delivering the same high standards and support as our on-campus programs."
    },
    faqSection: {
      label: "Online School FAQs",
      title: "Frequently Asked Questions",
      items: [
        {
          question: "Who can enroll in S-TEE Online?",
          answer: "Any student seeking quality education from anywhere in the world."
        },
        {
          question: "Are classes live or recorded?",
          answer: "Most classes are live, but recordings are available for review."
        }
      ]
    },
    stepsSection: {
      label: "How to Register",
      title: "Steps to Join S-TEE Online",
      items: [
        {
          title: "Fill the Registration Form",
          text: "Start your journey by completing our simple online registration."
        },
        {
          title: "Attend Orientation",
          text: "Get to know our teachers and online platform."
        },
        {
          title: "Begin Classes",
          text: "Join your first live class and start learning!"
        }
      ]
    },
    sidebarSection: null,
    newsSection: {
      label: "Online School News",
      title: "Latest Updates",
      items: [
        {
          title: "Online School Registration Now Open",
          text: "Enroll for the new session and experience world-class learning online.",
          tag: "Announcement",
          meta: "April 2026"
        }
      ]
    },
    footerCta: {
      title: "Ready to Join S-TEE Online?",
      text: "Take the next step and experience S-TEE's world-class education from anywhere. Register now or contact us to learn more about our online program.",
      ctaLabel: "Register Online",
      ctaPath: "/admissions/online"
    }
  },
  {
    path: "/academics/culture",
    eyebrow: "S-Tee Culture",
    title: "The culture that shapes life at S-TEE",
    description:
      "S-TEE culture sets a high standard for student behaviour, learning habits, and appearance. It helps learners understand that they represent the school both inside and outside the classroom.",
    heroImage: Banner4,
    heroImageAlt: "School community gathering together",
    stats: [
      { value: "Academics", label: "serious learning habits" },
      { value: "Attitude", label: "respectful conduct" },
      { value: "Appearance", label: "smart representation" },
    ],
    focus: {
      label: "The Triple A Principle",
      title: "School life stays clearer when expectations are simple and consistent",
      text:
        "S-TEE culture is built around three connected areas that help students learn well, relate well, and represent the school with pride.",
      list: [
        "Academics: attendance, homework, honesty, and seriousness in assessments matter.",
        "Attitude: punctuality, respect, orderliness, and self-control are expected daily.",
        "Appearance: neat dressing, proper grooming, and smart presentation reflect the school well.",
      ],
    },
    callout: {
      label: "Why Culture Matters",
      title: "A disciplined culture creates the kind of environment where learners thrive",
      text:
        "Parents gain confidence when the school is clear about standards. Students grow better when expectations are visible, fair, and consistently reinforced.",
      ctaLabel: "View Gallery",
      ctaPath: "/gallery",
    },
    cardsSection: {
      label: "Culture In Practice",
      title: "How these expectations show up across school life",
      items: [
        {
          title: "Academic Responsibility",
          text:
            "Students are encouraged to attend classes consistently, complete work on time, and treat tests, assignments, and school routines seriously.",
        },
        {
          title: "Positive Attitude",
          text:
            "Respect for adults and peers, punctuality, and responsible conduct help build a healthy school community.",
        },
        {
          title: "Pride In Appearance",
          text:
            "Uniform, grooming, and presentation are treated as part of the discipline and self-respect expected of every learner.",
        },
      ],
    },
    statementSection: {
      label: "Daily Expectations",
      title: "Examples of the standards families and students should understand",
      text:
        "These practical standards help families and students see how discipline is lived every day at S-TEE.",
      items: [
        "Students are expected to attend classes consistently and take academic work seriously.",
        "Bullying, disorderliness, cheating, and disrespectful behaviour have no place in the school community.",
        "Punctuality, neat dressing, and responsible use of school space help protect the learning environment for everyone.",
      ],
      note:
        "These points can be expanded later with the school's fuller culture document if needed.",
    },
    footerCta: {
      title: "Want to show families how culture connects to admissions?",
      text:
        "The admissions pages now make it easier to move from school identity into the application journey.",
      ctaLabel: "Open Admissions",
      ctaPath: "/admissions",
    },
  },
  {
    path: "/academics/anthem",
    eyebrow: "School Anthem",
    title: "The school anthem that reinforces pride and shared identity",
    description:
      "The S-TEE anthem gives students a common language of pride, aspiration, and belonging. It supports assemblies, ceremonies, and other moments where the school voice is meant to be shared together.",
    heroImage: Banner1,
    heroImageAlt: "School ceremony or event setting",
    stats: [
      { value: "Assemblies", label: "shared participation" },
      { value: "Schoolwide", label: "sense of belonging" },
      { value: "Identity", label: "expressed together" },
    ],
    focus: {
      label: "School Anthem",
      title: "School Anthem",
      text: `**Verse 1**\nArise and shine\nS-TEE the school of Kings and Queens\nWe are leaders of tomorrow that will build this nation\nWe are set to prove our school\nOh great S-TEE\nWhere knowledge is power\nWe shall brighten like the sun through the mercies of the Lord\nWe are set to prove our school\n\n**Chorus**\nWe are set\nWe are set\nWe are set for the state\nWe are set for the nation\nWe are set for the world\nWe are set to prove our school\n\n**Verse 2**\nSo Arise hail Kings and Queens\nFor we always set the pace\nWe twinkle like the stars and are bright like the moon\nWe are proud of S-TEE School\nSo arise hail Kings and Queens\nLeaders of tomorrow\nHumility's our code and the best we are\nWe are proud of S-TEE School\n\n**Chorus**\nWe are set\nWe are set\nWe are set for the state\nWe are set for the nation\nWe are set for the world\nWe are set to prove our school`,
      list: [],
    },
    callout: {
      label: "Shared Identity",
      title: "The anthem makes more sense when it sits beside culture and creed",
      text:
        "Together, these pages present a fuller picture of how S-TEE combines school spirit, discipline, and shared purpose.",
      ctaLabel: "Open School Creed",
      ctaPath: "/academics/creed",
    },
    cardsSection: {
      label: "What The Anthem Reinforces",
      title: "The anthem carries more meaning when families understand what it reinforces",
      items: [
        {
          title: "Belonging",
          text:
            "The anthem gives students a shared language of belonging, pride, and school identity.",
        },
        {
          title: "Consistency",
          text:
            "Keeping the anthem in one place makes it easier for families, learners, and staff to return to the same official version.",
        },
        {
          title: "Ceremonial Meaning",
          text:
            "The anthem speaks to the school moments that shape memory, discipline, and shared identity across the community.",
        },
      ],
    },
    statementSection: {
      label: "THE S-TEE SCHOOL ANTHEM",
      title: "THE S-TEE SCHOOL ANTHEM",
      text: null,
      items: [],
      note: null,
    },
    footerCta: {
      title: "Need the values that sit beside the anthem?",
      text:
        "The creed page continues the same school-identity story in a more direct and practical way.",
      ctaLabel: "View School Creed",
      ctaPath: "/academics/creed",
    },
  },
  {
    path: "/academics/creed",
    eyebrow: "School Creed",
    title: "A creed that turns school values into daily commitments",
    description:
      "The S-TEE creed reinforces the attitudes the school wants students to carry into learning, conduct, and leadership. It gives the community a practical language for responsibility and perseverance.",
    heroImage: Kd1,
    heroImageAlt: "Students gathered for a school moment",
    stats: [
      { value: "Hard Work", label: "over excuses" },
      { value: "Integrity", label: "in everyday conduct" },
      { value: "Purpose", label: "for the future" },
    ],
    focus: {
      label: "Why The Creed Matters",
      title: "Students benefit when school values sound like real commitments",
      text:
        "A creed becomes more powerful when it is explained clearly and tied to the kind of behaviour the school wants to see every day.",
      list: [
        "It pushes students toward perseverance instead of fear or mediocrity.",
        "It reinforces honesty, respect, and responsible choices within the school community.",
        "It reminds learners that success grows through effort, accountability, and consistency.",
      ],
    },
    callout: {
      label: "The Bigger Picture",
      title: "Culture, anthem, and creed work best when they support one another",
      text:
        "Together they help families understand that S-TEE is shaping character and identity, not just academic outcomes.",
      ctaLabel: "Back To Academics",
      ctaPath: "/academics",
    },
    cardsSection: {
      label: "Key Ideas In The Creed",
      title: "The S-TEE School Creed: Our Shared Commitments",
      items: [
        {
          title: "S-TEE SCHOOL CREED",
          text: `We are students of S-TEE School.\n\nWe are exceptional not because we say it but because we work hard at it.\n\nWe will not falter in the face of any obstacle placed before us.\n\nWe are dedicated, committed and focused\n\nWe never succumb to mediocrity, uncertainty or fear\n\nWe never fail because we never give up and we make no excuses\n\nWe choose to live honestly, non-violently and honourably\n\nWe respect ourselves and in doing so, respect all people\n\nWe have a future for which we are accountable and we believe there is no magic formula for success\n\nThe key is hard work and perseverance\n\nWe are destined to succeed\n\nWe are star students of S-TEE School.`
        },
      ],
    },
    statementSection: {
      label: "Creed Commitments",
      title: "Living Out the S-TEE Creed",
      text:
        "At S-TEE, our creed is more than words—it's a daily guide for how we learn, act, and grow together. These commitments help every student and family understand the values we strive to live by, both in and out of the classroom:",
      items: [
        "We work hard, stay focused, and never settle for mediocrity.",
        "We choose honesty, respect, self-control, and responsibility in all we do.",
        "We believe our future is built through perseverance, accountability, and purposeful effort."
      ],
      note:
        "The full S-TEE School Creed remains a clear statement of the habits, mindset, and responsibility expected from every learner.",
    },
    footerCta: {
      title: "Take the Next Step with S-TEE",
      text:
        "If our values resonate with your family, we invite you to learn more about joining the S-TEE community. Discover how our admissions process helps new students become part of our story.",
      ctaLabel: "Explore Admissions",
      ctaPath: "/admissions",
    },
  },
];
